import { EventEmitter } from 'events';

export class ZWebSocket extends EventEmitter
{
    // Instância WebSocket
    private webSocket: WebSocket;

    // Endereço do servidor WebSocket
    private address: string;

    // Opções de reconexão
    private reconnectionOptions: ZWebSocketReconnectionOptions;

    // Timer de reconexão
    private reconnectionTimer: any = null;

    /**
     * Construtor da classe
     *
     * @param address                   Endereço WebSocket a ser tentada a conexão
     * @param reconnectionInterval      Opções de reconexão
     */
    constructor(address: string, reconnectionOptions: ZWebSocketReconnectionOptions = null)
    {
        super();

        // Referência para essa classe
        const self = this;

        // Inicializa as variáveis
        this.webSocket = null;

        // Opções de reconexão não definidas?
        if (reconnectionOptions === null)
        {
            // Define as opções padrão
            this.reconnectionOptions = {
                interval: 2500,
                enabled: true
            };
        }
        else
        {
            // Utiliza as opções definidas
            this.reconnectionOptions = reconnectionOptions;
        }

        // Reconexão ativa?
        if (this.reconnectionOptions.enabled)
        {
            // Inicia o timer de reconexão
            this.reconnectionTimer = setInterval(() =>
            {
                // Sem conexão?
                if (!self.IsConnected())
                {
                    // Tenta a conexão
                    self.Connect();
                }

            }, this.reconnectionOptions.interval);
        }

        // Guarda o endereço de conexão
        this.address = address;
    }

    /**
     * Função que solicita a conexão
     */
    public Connect()
    {
        // WebSocket não instanciada?
        if (this.webSocket === null)
        {
            try
            {
                // Cria a instância
                this.webSocket = new WebSocket(this.address);

                // Evento de conexão
                this.webSocket.onopen = ((event: Event): any =>
                {
                    // Emite o evento de conexão
                    this.emit('connected');
                });

                // Evento de desconexão
                this.webSocket.onclose = ((event: CloseEvent) =>
                {
                    // Emite o evento de desconexão
                    this.emit('disconnected');

                    // Anula a referência da WebSocket
                    this.webSocket = null;
                });

                // Evento de mensagem recebida
                this.webSocket.onmessage = ((event: MessageEvent) =>
                {
                    try
                    {
                        // Parseia o conteúdo recebido
                        const jsonData = JSON.parse(event.data);

                        // Emite o evento com a mensagem parseada
                        this.emit('message', jsonData);
                    }
                    catch (error)
                    {
                    }
                });

                // Evento de erro
                this.webSocket.onerror = ((event: Event) =>
                {
                });
            }
            catch (error)
            {
            }
        }
    }

    /**
     * Função que envia dados para o servidor
     *
     * @param data      Dados a serem enviados
     */
    public Send(data: string): boolean
    {
        // Sem conexão?
        if (!this.IsConnected())
            return false;

        // Envia os dados
        this.webSocket.send(data);

        return true;
    }

    /**
     * Função que informa se o cliente está conectado ao servidor
     *
     * @returns         Verdadeiro se o cliente está conectado ao servidor
     */
    public IsConnected(): boolean
    {
        return (this.webSocket !== null && this.webSocket.readyState === WebSocket.OPEN);
    }
}

export interface ZWebSocketReconnectionOptions
{
    // Reconexão ativa?
    enabled: boolean;

    // Intervalo entre as tentativas
    interval: number;
}
